import { useSelector } from '@xstate/react';

import { useGlobalAppState } from '../../GlobalAppState';

export const useCustomerData = () => {
  const { authMachineRef } = useGlobalAppState();

  return useSelector(authMachineRef, (state) => {
    return state.context.currentCustomer;
  });
};
